import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const StyledText = styled.div(({ theme: { fontSize, colors } }) => ({
  backgroundColor: colors.grey,
  borderRadius: '20px',
  color: colors.white,
  fontSize: fontSize * 0.75,
  fontWeight: '700',
  lineHeight: `${fontSize}px`,
  overflow: 'hidden',
  padding: '4px 9px',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}))

const ProductPagination = ({ children }) => (
  <StyledText data-test="ProductPagination">
    {children}
  </StyledText>
)

ProductPagination.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
}

ProductPagination.defaultProps = {
  children: '',
}

ProductPagination.displayName = 'ProductPagination'
ProductPagination.whyDidYouRender = true

export default React.memo(ProductPagination)
